import React from 'react';
import { useToast } from '../contexts/ToastContext';
import './ToastContainer.css';

const typeToClass = (type) => {
  switch (type) {
    case 'success': return 'toast-success';
    case 'warning': return 'toast-warning';
    case 'error': return 'toast-error';
    default: return 'toast-info';
  }
};

const ToastContainer = () => {
  const { toasts, removeToast } = useToast();
  return (
    <div className="toast-container">
      {toasts.map(t => (
        <div key={t.id} className={`toast ${typeToClass(t.type)}`} onClick={() => removeToast(t.id)}>
          <div className="toast-message">{t.message}</div>
        </div>
      ))}
    </div>
  );
};

export default ToastContainer;


